export default "__VITE_ASSET__CNTKmi7o__"